/* eslint-disable no-console */

const zoom = "zoom zoom 🚗 (◠‿◠✿)✌️"

let didZoomZoom = false

export default function ZoomZoom() {
  if (didZoomZoom) return
  didZoomZoom = true
  console.log(zoom)
}



// WEBPACK FOOTER //
// ./src/utils/zoom-zoom.js